
import TokenService from "./tokenlocalstorage.service";
import { postRequest } from "./axiosBaseClient";
import { postRequest as post } from "./axiosBaseAuthClient";
import ReactGA from 'react-ga';

class AuthService {
  login(userName, password) {
    ReactGA.event({
      category: 'Button Click',
      action: 'Login',
      label: 'Login page',
    });
    
    return post("bss/basicAuth", {
      userName,
      password,
    }).then(
      (response) => {
        if (response?.data?.accessToken) {
          TokenService.setToken(response.data);
        }
        return response;
      },
      (error) => {
        return error.response;
      }
    );
  }
  logout() {
    TokenService.clear();
  }
  getCurrentToken() {
    return TokenService.getToken();
  }
  getUserName() {
    return TokenService.get("user-name");
  }

  resetPassword(password, serialId, otp) {
    let encodedId=encodeURIComponent(serialId);
    return post(
      "bss/resetPassword?password=" +
        password +
        "&serialId=" +
        encodedId +
        "&otp=" +
        otp
    );
  }
  getUserName() {
    return TokenService.get("user-name");
  }

  forgotPassword(emailId) {
    return post("bss/sendEmail", {
      emailId: emailId,
    });
  }
}
export default new AuthService();
